// data/deckService.js
// Accès table decklists (UI-agnostic).

import { getSupabaseClient } from "../infra/supabaseClient.js";

export async function listDecks(){
  const client = getSupabaseClient();
  const { data, error } = await client
    .from("decklists")
    .select("id,name,updated_at")
    .order("updated_at", { ascending: false });
  if(error) throw error;
  return data || [];
}

export async function loadDeck(id){
  const client = getSupabaseClient();
  const { data, error } = await client
    .from("decklists")
    .select("id,name,deck,updated_at")
    .eq("id", id)
    .single();
  if(error) throw error;
  return data;
}
